// extracted by mini-css-extract-plugin
module.exports = {"container":"MufeBox_container__2vwBh","searchBox":"MufeBox_searchBox__2gsCK"};